import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CONTACT } from "../../data/site";
import { revealUp, staggerParent, viewportOnce } from "../../lib/motion";

export const MenuCTA = () => {
  const orderHref = `https://maps.google.com/?q=${encodeURIComponent(CONTACT.mapsQuery)}`;

  return (
    <section data-testid="menu-cta" className="py-4 pb-10 sm:py-8 sm:pb-16">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={staggerParent}
          className="w-full rounded-[28px] bg-labred px-6 py-16 text-center sm:px-12 sm:py-24"
        >
          <motion.p variants={revealUp} className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
            TASTE THE RESULT
          </motion.p>
          <motion.h2 variants={revealUp} className="mx-auto max-w-3xl font-display text-3xl leading-[1.08] tracking-tight text-paper sm:text-5xl">
            HUNGRY FOR THE RESULTS?
          </motion.h2>

          <motion.div variants={revealUp} className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <a
              href={orderHref}
              target="_blank"
              rel="noreferrer"
              data-testid="menu-cta-order"
              className="inline-flex items-center justify-center rounded-full bg-paper px-8 py-3.5 font-display text-xs uppercase tracking-wider text-inkred transition-colors duration-150 hover:bg-labyellow"
            >
              Order Now
            </a>
            <Link
              to="/contact"
              data-testid="menu-cta-find"
              className="inline-flex items-center justify-center rounded-full border border-paper/60 bg-transparent px-8 py-3.5 font-display text-xs uppercase tracking-wider text-paper transition-colors duration-150 hover:border-labyellow hover:text-labyellow"
            >
              Find Us
            </Link>
          </motion.div>

          <motion.p variants={revealUp} className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-paper/70">
            1216 MAIN AVE&nbsp;&nbsp;//&nbsp;&nbsp;908 333 6363&nbsp;&nbsp;//&nbsp;&nbsp;@CHICKENLABB_OFFICIAL
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
};
